/*
    We maintain a list of always cached tables here. When we add a table that should always be
    cached, we subscribe to the row notifications.
*/
var tableIdList;
var onAdd;
var onRemove;
export function initialize(onAddCallback, onRemoveCallback) {
    tableIdList = [];
    onAdd = onAddCallback;
    onRemove = onRemoveCallback;
}
export function add(tableView) {
    var tableViewIndex = indexOf(tableView);
    if (tableViewIndex === -1) {
        tableIdList.push(tableView.id);
        onAdd(tableView);
    }
    return tableViewIndex;
}
export function remove(tableView) {
    var tableViewIndex = indexOf(tableView);
    if (tableViewIndex !== -1) {
        tableIdList.splice(tableViewIndex, 1);
        onRemove(tableView.id);
    }
}
export function indexOf(tableView) {
    return tableIdList.indexOf(tableView.id);
}
export function getTableIdAtIndex(index) {
    return tableIdList[index];
}
//# sourceMappingURL=alwaysInCacheTableIdList.js.map